import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { map, Observable } from 'rxjs';

import { ProductsService } from '@prlw/core/products/products.service';
import { Product } from '@prlw/core/products/product.entity';
import { OverflowFader } from '@prlw/libs/overflow-fader/overflow-fader.class';
import { OverflowFaderFactory } from '@prlw/libs/overflow-fader/overflow-fader-factory.service';

@Component({
  selector: 'prlw-product-filter',
  templateUrl: './product-filter.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFilterContainer implements OnDestroy {
  public readonly products$: Observable<Product[]>;
  public readonly selectedProducts$: Observable<Product[]>;
  public readonly isOverflowRight$: Observable<boolean>;
  public readonly isOverflowLeft$: Observable<boolean>;
  private readonly overflowFader: OverflowFader;
  public readonly areProductsOfCurrentGroupLoaded$: Observable<boolean>;

  constructor(
    private readonly productsService: ProductsService,
    overflowFaderFactory: OverflowFaderFactory,
    cdr: ChangeDetectorRef,
  ) {
    this.products$ = this.productsService.productsOfCurrentGroup$;
    this.selectedProducts$ =
      this.productsService.selectedProductsOfCurrentGroup$;
    this.overflowFader = overflowFaderFactory.create(cdr);
    this.isOverflowRight$ = this.overflowFader.isOverflowRight$;
    this.isOverflowLeft$ = this.overflowFader.isOverflowLeft$;

    this.areProductsOfCurrentGroupLoaded$ =
      productsService.productsOfCurrentGroupWithPending$.pipe(
        map((item) => !item.pending),
      );
  }

  public toggleProduct(product: Product): void {
    this.productsService.toggleProduct(product);
  }

  public toggleAllProductsOfCurrentGroup(): void {
    this.productsService.toggleAllProductsOfCurrentGroup();
  }

  public setScrollHorizontalPosition(scrollLeft: number): void {
    this.overflowFader.setScrollHorizontalPosition(scrollLeft);
  }

  public initResizeObserver(element: HTMLElement): void {
    this.overflowFader.init({ elemX: element, elemY: element }, [
      this.productsService.selectedProductsOfCurrentGroup$,
    ]);
  }

  public ngOnDestroy(): void {
    this.overflowFader.destroy();
  }
}
